import { useEffect } from 'react';
import { useLanguageStore } from '@/stores/languageStore';

export const useLanguage = () => {
  const { language, setLanguage, toggleLanguage, initializeLanguage } = useLanguageStore();

  useEffect(() => {
    initializeLanguage();
  }, [initializeLanguage]);

  return {
    language,
    setLanguage,
    toggleLanguage,
    isRTL: language === 'ar',
    isLTR: language === 'en',
  };
};

